import { IntrospectionFragmentMatcher } from 'apollo-cache-inmemory';

// @ts-ignore
import fragmentMatcherAGGTypes from './types/fragmentMatcherAGGTypes.json';

/*
This can be regenerated by running the following introspection query against the AGG endpoint:
{
    __schema {
        types {
            kind
            name
            possibleTypes {
                name
            }
        }
    }
}
*/

export const fragmentMatcher: IntrospectionFragmentMatcher = new IntrospectionFragmentMatcher({
	introspectionQueryResultData: {
		__schema: {
			types: fragmentMatcherAGGTypes,
		},
	},
});
